import ArchiveDetails from './ArchiveDetails.component';

export default ArchiveDetails;